import { formatBrDateHour } from "../../../../infra/helpers/date";
import { LoadingPage } from "../../../../shared/components/LoadingPage";
import { CreateModal } from "../../../../shared/components/Modal";
import { useGetAuditoriaForId } from "../../hooks/useGetAuditoria";
import { formatString } from "../../utils/formatString";
import { GridModalAuditoria } from "./GridModalAuditoria";

interface ModalVisualizarProps {
  onCancel: () => void;
  visible: boolean;
  auditoriaId: number;
}

export function ModalVisualizar({ visible, onCancel, auditoriaId }: ModalVisualizarProps) {
  const { data, isLoading } = useGetAuditoriaForId(auditoriaId)

  const Antes = formatString(data?.Antes);
  const Depois = formatString(data?.Depois);

  return (
    <CreateModal
      title="Detalhe de Auditoria"
      isModalOpen={visible}
      onCancel={onCancel}
      hideButton
    >
      {isLoading ?
        (
          <div className="w-[60rem] h-[35rem] flex justify-center items-center">
            <LoadingPage />
          </div>
        ) : (
          <div className="w-[60rem] h-[35rem] overflow-hidden overflow-y-auto">
            <div>
              <InfoModal title="Data" info={formatBrDateHour(data?.RegCriacaoData)} />
              <div className="flex gap-10">
                <InfoModal title="Usuário" info={data?.RegCriacaoUsuarioLogin} />
                <InfoModal title="Tabela" info={data?.Tabela} />
                <InfoModal title="Ação" info={data?.Acao} />
                <InfoModal title="Chave" info={data?.Chave} />
              </div>
            </div>

            <GridModalAuditoria antes={Antes} depois={Depois} />

          </div>
        )
      }
    </CreateModal>
  );
}

interface Teste {
  title: string,
  info: string
}

function InfoModal({ title, info }: Teste) {
  return (
    <span>
      <b>{title}: </b>
      {info}
    </span>
  );
}
